import React, { Component } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import * as utilities from '../../utilities';

class CopyString extends Component {

    handleCopy = (e) => {
        e.stopPropagation();
        const { textToCopy } = this.props;

        // Copy text to clipboard
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    utilities.addToast(`${textToCopy} is copied to the clipboard`, 5, 'success');
                })
                .catch((err) => {
                    utilities.addToast(`Could not copy text to clipboard`, 5, 'danger');
                    console.error('Could not copy text: ', err);
                });
        } else {
            // Fallback for older browsers
            this.fallbackCopyTextToClipboard(textToCopy);
        }
    }

    fallbackCopyTextToClipboard = (text) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';  // Prevent scrolling to bottom
        textarea.style.opacity = '0';       // Hide the textarea
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            const successful = document.execCommand('copy');
            if (successful) {
                utilities.addToast(`${text} is copied to the clipboard`, 5, 'success');
            } else {
                utilities.addToast(`Could not copy text to clipboard`, 5, 'danger');
                console.error('Fallback: Copy command was unsuccessful');
            }
        } catch (err) {
            utilities.addToast(`Could not copy text to clipboard`, 5, 'danger');
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textarea);
    }

    render() {
        return (
            <Button outline onClick={this.handleCopy} size='sm' color='primary'>
                <FontAwesomeIcon icon={faCopy} />
            </Button>
        );
    }
}

export default CopyString;